import { Component } from '@angular/core';

@Component({
  selector: 'app-modal-no-selected-goods',
  templateUrl: './modal-no-selected-goods.component.html',
  styleUrls: ['./modal-no-selected-goods.component.scss']
})
export class ModalNoSelectedGoodsComponent {
  isModalShow = false;
  isDarkBackground = false;
  openModal() {
    this.isModalShow = true;
    this.isDarkBackground = true;
  }

  closeModal() {
    this.isModalShow = false
    this.isDarkBackground = false;
  }
}
